/* 시스템 전역 상수.
   기존에는 28개 파일이 각자 `const APP_ID = 'imperial-clinic-v1'`을 선언하고 있었습니다.
   값이 하나뿐인 데이터인데 선언이 28벌이면, 바꿔야 할 때 한 곳만 빠뜨려도
   그 화면만 조용히 다른 곳을 바라보게 됩니다. */

export const APP_ID = 'imperial-clinic-v1';

/** Firestore 공용 데이터 경로를 만듭니다. 예: dataPath('users') */
export const dataPath = (collectionName) =>
  `artifacts/${APP_ID}/public/data/${collectionName}`;

/* 학생·학부모·교직원이 로그인하는 시스템 주소.
   예전에는 상담 온보딩 문자에 옛 Firebase 기본 호스팅 주소(…web.app)가 박혀 있었는데,
   그 주소는 404 였습니다(2026-10-29 확인). 그래서 안내 문자를 받은 가족이 접속할 곳을 찾지 못했습니다.
   문자·안내문에 시스템 주소를 넣을 때는 이 값만 씁니다. 홈페이지(index.html)도 같은 주소를 씁니다. */
export const SYSTEM_URL = 'https://system.imperialwith.com';

/* 임페리얼 북스(교재 판매 사이트). 별도 사업자이며 결제는 그쪽 페이지에서 이루어집니다.
   이 시스템은 반마다 교재를 지정하고, 학생에게 '무엇을 사야 하는지' 안내하고,
   결제된 주문을 데스크가 전달 처리하는 역할만 합니다.
   북스가 별도 도메인으로 옮겨 가면 이 두 값만 바꾸면 됩니다.
   (서버 쪽 카탈로그 주소는 functions/.env 의 BOOKS_CATALOG_URL 로 따로 맞춥니다) */
export const BOOKS_SITE_URL_PROD = 'https://imperialbooks.co.kr';   // 북스 전용 도메인 (2026-10-08)

/* 로컬 점검(npm start, 개발 모드)에서는 북스 로컬 서버(npm run store, localhost:8788)를 먼저 봅니다.
   북스 저장소에서 교재를 추가·수정한 뒤 배포하기 전에도 시스템 로컬에서 바로 확인하기 위해서입니다.
   로컬 서버가 꺼져 있으면 배포본으로 넘어갑니다. 배포 빌드에서는 배포본만 씁니다. */
const IS_DEV = process.env.NODE_ENV === 'development';
const BOOKS_SITE_URL_LOCAL = 'http://localhost:8788';
/* 로컬 시스템에서 '배포된 북스'를 상대로 점검할 때: REACT_APP_BOOKS_PROD=1 npm start
   (로그인 이어가기처럼 운영 북스 페이지와 맞물려야 확인되는 기능용, 10-09) */
const USE_PROD_BOOKS = IS_DEV && process.env.REACT_APP_BOOKS_PROD === '1';

export const BOOKS_SITE_URL = (IS_DEV && !USE_PROD_BOOKS) ? BOOKS_SITE_URL_LOCAL : BOOKS_SITE_URL_PROD;
export const BOOKS_CATALOG_URL = `${BOOKS_SITE_URL_PROD}/assets/books-catalog.json`;
/** 카탈로그를 읽을 주소 후보. 앞에서부터 시도해 처음 성공한 것을 씁니다. */
export const BOOKS_CATALOG_URLS = IS_DEV
    ? [`${BOOKS_SITE_URL_LOCAL}/assets/books-catalog.json`, BOOKS_CATALOG_URL]
    : [BOOKS_CATALOG_URL];
